import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import { TApiServiceError } from "../apiService";
import { rootNotificationEndpoint } from "../../core/apiurl";
import { notificationsService } from "./notifications.service";
import {
  TClearSingleNotificationResponse,
  TNotificationsResponse,
  TReadUserNotificationResponse,
} from "./notifications.types";

// Define query key constant
export const GET_NOTIFICATIONS_QUERY_KEY = `${rootNotificationEndpoint}/notifications`;

export const useUserNotifications = (
  pageNo: number,
  options?: Omit<
    UseQueryOptions<TNotificationsResponse, TApiServiceError>,
    "queryKey" | "queryFn"
  >,
) => {
  return useQuery<TNotificationsResponse, TApiServiceError>({
    queryKey: [GET_NOTIFICATIONS_QUERY_KEY, pageNo],
    queryFn: () => notificationsService.getUserNotifications(pageNo),
    ...options,
  });
};

export const useReadUserNotification = (
  options?: UseMutationOptions<
    TReadUserNotificationResponse,
    TApiServiceError,
    string
  >,
) => {
  return useMutation<TReadUserNotificationResponse, TApiServiceError, string>({
    mutationFn: (id: string) =>
      notificationsService.readUserNotification(id, {}),
    ...options,
  });
};
// Mutation for clearing single notifications on demand (e.g., Clear all button)

export const useClearNotification = (
  options?: UseMutationOptions<
    TClearSingleNotificationResponse,
    TApiServiceError,
    string
  >,
) => {
  return useMutation<
    TClearSingleNotificationResponse,
    TApiServiceError,
    string
  >({
    mutationFn: (id: string) =>
      notificationsService.clearSingleNotification(id, {}),
    ...options,
  });
};

// Mutation for clearing all notifications on demand (e.g., Clear all button)
export const useClearAllNotifications = (
  options?: UseMutationOptions<TNotificationsResponse, TApiServiceError, void>,
): UseMutationResult<
  TNotificationsResponse,
  TApiServiceError,
  void,
  unknown
> => {
  return useMutation<TNotificationsResponse, TApiServiceError, void>({
    mutationFn: async (): Promise<TNotificationsResponse> => {
      const response = await notificationsService.clearUserNotifications(
        "true",
        {},
      );
      return response;
    },
    ...options,
  });
};
